module.exports = __webpack_public_path__ + "static/media/contrato.4b80546e.svg";